var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckcircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.677 10.329a.8.8 0 10-1.104-1.158l-4.948 4.723-2.198-2.098a.8.8 0 10-1.104 1.158l2.75 2.625a.8.8 0 001.104 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2.2c-5.412 0-9.8 4.388-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8zM3.8 12a8.2 8.2 0 1116.4 0 8.2 8.2 0 01-16.4 0z",
    fillRule: "evenodd"
  }))));
}

export default SvgCheckcircle;